import { render, staticRenderFns } from "./Brazil.vue?vue&type=template&id=3f6d9eb5&"
import script from "./Brazil.vue?vue&type=script&lang=js&"
export * from "./Brazil.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3f6d9eb5')) {
      api.createRecord('3f6d9eb5', component.options)
    } else {
      api.reload('3f6d9eb5', component.options)
    }
    module.hot.accept("./Brazil.vue?vue&type=template&id=3f6d9eb5&", function () {
      api.rerender('3f6d9eb5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/icons/countries/Brazil.vue"
export default component.exports